import { useResultPageStore } from '../stores/ResultPageStore';
import { useUserStore } from '../../../../../../lib-sat/store/modules/user-store';
import { mapState, mapStores } from 'pinia';

export default {
    props: {},
    data() {
        return {};
    },
    created: function () {},
    mounted: function () {},

    methods: {},
    computed: {
        ...mapStores(useResultPageStore, useUserStore),
        ...mapState(useResultPageStore, ['resultPage', 'getBase64', 'getJobById', 'getSettings', 'getOutputById', 'getOpenTabs', 'addTab']),
        ...mapState(useUserStore, ['user', 'getUser']),
    },
};
